import {
  NOT_GETLISTADO_START,
  NOT_GETPUBLICACION_START,
  NOT_GETLISTADOADMIN_START,
  NOT_DOWNLOAD_START,
  NOT_DELETE_START,
  NOT_SENDPUB_START,
  NOT_SAVE_START,
  NOT_GETNTF_START,
  NOT_RESPONDERNTF_START,
    NOT_PRUEBA_START, NOT_FINLLAMADA_START
} from "../../const/actionTypes";
export const GetNotificacionesAdmin = (payload) => ({
  type: NOT_GETLISTADOADMIN_START,
  payload,
});
export const GetNotificaciones = (payload) => ({
  type: NOT_GETLISTADO_START,
  payload,
});
export const GetPublicaciones = (payload) => ({
  type: NOT_GETPUBLICACION_START,
  payload,
});
export const DownloadFile = (payload) => ({
  type: NOT_DOWNLOAD_START,
  payload,
});
export const EliminarNotificacion = (payload) => ({
  type: NOT_DELETE_START,
  payload,
});
export const GrabarNotificacion = (payload) => ({
  type: NOT_SAVE_START,
  payload,
});
export const SendPublicacion = (payload) => ({
  type: NOT_SENDPUB_START,
  payload,
});

export const GetNtf = (payload) => ({
  type: NOT_GETNTF_START,
  payload,
});
export const ResponderNtf = (payload) => ({
  type: NOT_RESPONDERNTF_START,
  payload,
});
export const LlamadaPrueba = (payload) => ({
  type: NOT_PRUEBA_START,
  payload,
});
export const FinLlamada = (payload) => ({
    type: NOT_FINLLAMADA_START,
  payload,
});
